import { configureRequest, setUser } from '@wikom/wikom-data';
import React, { useMemo } from 'react';
import { Provider } from 'react-redux';
import { useHistory } from '@wikom/wikom-router';
import ErrorHandlerContainer from '@wikom/frontend-logger';
import Page from '../common/layout/Page';
import getSessionId from '../common/helpers/getSessionId';
import AppRoutes from './AppRoutes';
import { useRoute } from './router';
import configureStore from './store';
export var App = function () {
    var history = useHistory();
    var ROUTE = useRoute();
    var store = useMemo(function () {
        var store = configureStore(history, ROUTE);
        store.dispatch(setUser({ user: { access_token: getSessionId() } }));
        store.dispatch(configureRequest());
        return store;
    }, []);
    return (React.createElement(Provider, { store: store },
        React.createElement(ErrorHandlerContainer, { apiUrl: ROUTE.API.LOG.REPORT({ category: 'navigation' }) },
            React.createElement(Page, null,
                React.createElement(AppRoutes, null)))));
};
export default App;
